export default "__VITE_ASSET__DHJXNvWZ__"